import React, { Component } from 'react'
import ObjectPicker from './../misc/ObjectPicker'
import API from 'API'
import ENDPOINTS from 'config/endpoints'
class LinkedObjectPickerInput extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: null,
      title: '',
      components: this.props.components,
      systems: this.props.systems,
      modalState: false,
      display: '',
      result: {}
    }
  }
  getValueFromPath (path) {
    var obj = this.props.context.state
    var stack = path.split('.')
    while (stack.length) {
      obj = obj[stack.shift()]
    }
    this.setState({ 'value': obj, 'modalState': false })
    this.search(obj)
    return !obj
  }
  getValueFromPath2 (path) {
    var obj = this.props.context.state
    var stack = path.split('.')
    while (stack.length) {
      obj = obj[stack.shift()]
    }
    return obj
  }
  handleChange (e) {
    if (e == null) {
      this.props.context.setState(this.setValueAtPath(this.props.path, null || (this.props.nullable ? null : '')))
      this.setState({ display: '', 'value': '', 'modalState': false })
      this.props.context.forceUpdate()
    } else {
      this.props.context.setState(this.setValueAtPath(this.props.path, e.id || (this.props.nullable ? null : '')))
      this.getValueFromPath(this.props.path)
      this.props.context.forceUpdate()
    }
  }
  setValueAtPath (path, value) {
    var obj = this.props.context.state
    var current = obj
    var stack = path.split('.')
    while (stack.length > 1) {
      current = current[stack.shift()]
    }
    current[stack.shift()] = value
    return obj
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.updated === this.props.updated) return false
    var nextval = this.getValueFromPath2(this.props.path)
    if (this.state.value === nextval) return
    if (!nextval) {
      this.props.context.setState(this.setValueAtPath(this.props.path, null || (this.props.nullable ? null : '')))
      this.setState({ display: '', 'value': '', 'modalState': false })
      this.props.context.forceUpdate()
    } else {
      this.props.context.setState(this.setValueAtPath(this.props.path, nextval || (this.props.nullable ? null : '')))
      this.getValueFromPath(this.props.path)
      this.props.context.forceUpdate()
    }
  }

  validate () {
    if (!this.props.validate) return true
    return !!(((this.type.prototype.getValueFromPath.call(this, this.props.path)) + '').match(this.props.validate))
  }

  async componentDidMount () {
    this.getValueFromPath(this.props.path)
    if (/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.exec(this.props.value)) {
      var result = await API.make(ENDPOINTS.GLOBAL.SEARCH, {
        parameters: {
          search: this.props.value
        }
      })
      if (!result.total > 0) return
      this.setState({ display: result.data[0].description.replace(/,/g, ' ').replace(/ +/, ' '), value: this.props.value, result: result.data[0] })
    }
  }

  async componentDidUpdate (prevProps, prevState) {
    if (prevProps.path !== this.props.path || prevProps.value !== this.props.value) {
      if (/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.exec(this.props.value)) {
        var result = await API.make(ENDPOINTS.GLOBAL.SEARCH, {
          parameters: {
            search: this.props.value
          }
        })
        if (!result.total > 0) {
          this.setState({ display: '', value: this.props.value })
        } else {
          this.setState({ display: result.data[0].description.replace(/,/g, ' ').replace(/ +/, ' '), value: this.props.value })
        }
      } else if (this.props.value == null) {
        this.setState({ display: '', value: this.props.value })
      }
    }
  }
  async search (id) {
    if (!id) return
    var result = await API.make(ENDPOINTS.GLOBAL.SEARCH, {
      parameters: {
        search: id
      }
    })
    let filteredSearch = result.data.filter((item) => item.id === id)
    this.setState({ display: filteredSearch[0].title, value: id, result: filteredSearch[0] })
  }
  setValue (value, obj) {
    if (value !== this.state.value) {
      if (/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.exec(value)) {
        if (obj) {
          this.setState({ display: obj.description.replace(/,/g, ' ').replace(/ +/, ' ') })
        } else {
          this.setState({ display: '' })
        }
      } else {
        this.setState({ display: '' })
      }
    }
    this.setState({ value: value, modalState: false })
    this.handleChange(obj)
    if (this.props.callback) this.props.callback(obj)
  }
  render () {
    return (
      <div>
        <div className='input-group'>
          <input value={this.state.display}
            className='form-control'
            disabled
            onChange={(e) => {
              this.handleChange(e)
              if (this.props.onChange) this.props.onChange(e)
            }} />
          <span className='input-group-btn'>
            { <button className='btn btn-primary' disabled={!this.props.editable} hidden={!this.props.editable} type='button' onClick={() => this.setState({ modalState: true })}><i className='fa fa-search' /></button> }
            {!this.props.editable && <a href={`/#/${this.state.result.system}/${this.state.result.type}/${this.state.result.id}`} className='btn btn-primary' hidden={!this.props.editable} type='button' ><i className='fa fa-folder-open' /></a> }
            { (this.props.button && this.props.editable) && <button className='btn btn-primary' disabled={!this.props.editable} hidden={!this.props.editable} type='button' onClick={() => this.props.button.callback()}><i className={'fa fa-fw ' + this.props.button.icon} /></button> }
          </span>
        </div>
        <ObjectPicker
          modal={this.state.modalState}
          components={this.state.components}
          systems={this.state.systems}
          select={e => this.setValue(e.title, e)}
          closeModal={e => this.setState({ modalState: false })}
        />
      </div>
    )
  }
}
export default LinkedObjectPickerInput



// WEBPACK FOOTER //
// ./src/components/basic/inputs/LinkedObjectPickerInput.js